
import { Prop, Vue } from 'vue-property-decorator';

export default class RotateScreen extends Vue {
  @Prop() readonly isRotate!: boolean;
}
